import { COUNTRIES_PHRASES, PROFESSIONS_PHRASES } from 'consts/phrases/dictionaryPhrases';

export const REGISTER_INTRO_BLOCK = {
    INTRO_WELCOME_TEXT: 21414,
    INTRO_TITLE: 10659,
    INTRO_PARAGRAPH: 10660,
    INTRO_SURVEY_COMPLETE_TEXT: 2776,
    INTRO_SURVEY_ACCOUNT_RECORD_FOUND: 3552,
    INTRO_SURVEY_REGISTER_FOR_FREE_TEXT: 3550,
} as const;

export const FORM_STEP_PHRASES = {
    PERSONAL_DETAILS: 10412,
    PROFESSIONAL_DETAILS: 10413,
    ADDITIONAL_DETAILS: 14251,
    CONTACT_DETAILS: 10414,
    IDENTITY: 10633,
    ADDRESS: 38,
    NEXT: 84,
    PREVIOUS: 85,
    SUBMIT: 1972,
    REGISTER: 11,
} as const;

export const PERSONAL_DETAILS_PHRASES = {
    FIRST_NAME: 36,
    FIRST_NAME_REQUIRED_ERROR: 347,
    FIRST_NAME_INVALID_ERROR: 714,
    LAST_NAME: 37,
    LAST_NAME_REQUIRED_ERROR: 348,
    LAST_NAME_INVALID_ERROR: 715,
    EMAIL: 40,
    EMAIL_REQUIRED_ERROR: 354,
    EMAIL_INVALID_ERROR: 354,
    CONFIRM_EMAIL: 41,
    CONFIRM_EMAIL_REQUIRED_ERROR: 354,
    CONFIRM_EMAIL_INVALID_ERROR: 355,
    PASSWORD: 42,
    PASSWORD_REQUIRED_ERROR: 362,
    PASSWORD_INVALID_ERROR: 3677,
    CONFIRM_PASSWORD: 43,
    CONFIRM_PASSWORD_REQUIRED_ERROR: 362,
    CONFIRM_PASSWORD_INVALID_ERROR: 363,
    COUNTRY: 44,
    COUNTRY_REQUIRED_ERROR: 350,
    PROFESSION: 47,
    PROFESSION_REQUIRED_ERROR: 356,
    PREFERRED_LANGUAGE: 3261,
    PREFERRED_LANGUAGE_REQUIRED_ERROR: 3262,
    MARKET_RESEARCH: 10411,
    MARKET_RESEARCH_OPT_IN: 19281,
    MARKET_RESEARCH_REQUIRED_ERROR: 10611,
    CONSENTS: 10689,
    CONSENTS_REQUIRED_ERROR: 10673,
    AGE: 2801,
    AGE_REQUIRED_ERROR: 2802,
    PHOTO_TEXT: 13325,
    HOW_HEARD: 2111,
    COUNTRY_CANADA: COUNTRIES_PHRASES.CANADA,
    COUNTRY_UK: COUNTRIES_PHRASES.UNITED_KINGDOM,
    PROFESSION_PHYSICIAN: PROFESSIONS_PHRASES.PHYSICIAN_POST_TRAINING,
    PROFESSION_PHYSICIAN_ASSISTANT: PROFESSIONS_PHRASES.PHYSICIAN_ASSISTANT,
    PROFESSION_NURSING: PROFESSIONS_PHRASES.NURSING_PROFESSIONAL,
    PREFFERED_LANG_EN: 2129,
    PREFFERED_LANG_FR: 2131,
    HOW_HEARD_INSTAGRAM: 13229,
    REGISTRATION_LINK_EXPIRED_ERROR: 17729,
} as const;

export const PROFESSIONAL_DETAILS_PHRASES = {
    HOW_WE_USE_INFORMATION: 13326,
    MEDICAL_NUMBER: 10394,
    STATE_MEDICAL_COUNCIL: 21363,
    NPI_NUMBER: 10698,
    YEAR_OF_GRADUATE: 333,
    WHAT_MEDICAL_SCHOOL: 332,
    WHICH_STATE_OF_PRACTICE: 10799,
    PRIMARY_WORKPLACE_NAME: 14261,
    WORKPLACE_MAINLINE_NUMBER: 14263,
    PROFESSIONAL_ID_NUMBER: 14264,
    SELECT_SPECIALTY: 16073,
    WILL_NOT_PROVIDE_MEDICAL_NUMBER: 16074,
    MEDICAL_NUMBER_ERROR: 10635,

    CARDIOLOGY: 100500, // only for dev purposes
} as const;

export const CONTACT_DETAILS_PHRASES = {
    PHONE_ADDITION_TEXT: 10690,
    MOBILE_PHONE: 567,
    MOBILE_PHONE_INVALID_ERROR: 3771,
    CONFIRMATION_CODE: 10656,
    SEND_CODE: 3801,
    CONFIRMATION_CODE_INVALID_ERROR: 10657,
    ALTERNATIVE_PHONE: 10694,
    SMS_OPTIN: 2198,
    CAPTCHA_RESPONSE: 10860,
    CAPTCHA_RESPONSE_REQUIRED_ERROR: 10860,
    INVALID_CAPTCHA_RESPONSE: 261,
    CONFIRMATION_CODE_REQUIRED_ERROR: 16075,
    CONFIRMATION_CODE_TIMER_TEXT: 3773,
    TYPE_CODE: 15974,
    INVALID_MOBILE_PHONE_NUMBER: 3771,
};

export const IDENTITY_PHRASES = {
    STEP_ID_TYPE_TEXT: 16534,
    STEP_TAKE_PICTURE_TEXT: 16535,
    STEP_SCAN_FACE_TEXT: 16536,
    AGREE_TO_CONFIRM_BUTTON: 13330,
    SKIP_CONFIRMATION_BUTTON: 13331,
    YOTI_NOTES: 13329,
    MOBILE_BUTTON: 10692,
    DESKTOP_BUTTON: 10691,
    AWAIT_COMPLETION_LOADING_TEXT: 10695,
    MOBILE_COMPLETE_SUCCESS_TEXT: 10696,
    CANCEL_AWAIT_BUTTON: 189,
};

export const ADDRESS_PHRASES = {
    ADDRESS: 38,
    ZIP_CODE: 45,
    CITY: 46,
    STATE: 566,
    COUNTRY: 44,
};

export const ACTIVATE_PHRASES = {
    ALMOST_DONE: 16561,
    WHEN_YOU_REGISTERED: 16562,
    RESEND_EMAIL_CONFIRMATION: 16563,
};

export const REGISTRATION_COMPLETE_PHRASES = {
    REGISTRATION_COMPLETE: 22547,
    INTRO: 22548,
    ACTIVATE_PROMPT: 22549,
    EMAIL_TITLE: 22552,
    EMAIL_CONFIRM_HINT: 22550,
    EMAIL_CONFIRM_CHECK_SPAM: 22551,
    RESEND_EMAIL_CONFIRMATION: 16563,
    IDENTITY_TITLE: 22553,
    IDENTITY_VALIDATE_HINT: 22555,
    VERIFY_IDENTITY: 22554,
};
